import environment from "@/settings/environment";

const useCybersourceService = () => {
    const addCyberSourceScripts = (callback?: () => void) => {
        const existingHeaderScript = document.getElementById("script_cyber_header");
        const existingBodyScript = document.getElementById("script_cyber_body");
        
        if (existingHeaderScript && existingBodyScript) {
            callback?.();
            return;
        }

        removeCyberSouceScripts();

        const {
            orgId,
            merchantId,
        } = environment.api?.cybersource;

        const sessionId = `${merchantId}${generateUUID()}`

        const headerScript = document.createElement("script");
        headerScript.id = "script_cyber_header";
        headerScript.type = "text/javascript";
        headerScript.src = `https://h.online-metrix.net/fp/tags.js?org_id=${orgId}&session_id=${sessionId}`;
        headerScript.defer = true;  // Ou headerScript.async = true;
        document.head.appendChild(headerScript);

        const bodyScript = document.createElement("noscript");
        bodyScript.id = "script_cyber_body";

        const iframe = document.createElement("iframe");
        iframe.style.width = "100px";
        iframe.style.height = "100px";
        iframe.style.border = "0";
        iframe.style.position = "absolute";
        iframe.style.top = "-5000px";
        iframe.src = `https://h.online-metrix.net/fp/tags?org_id=${orgId}&session_id=${sessionId}`;

        document.body.appendChild(bodyScript);
        bodyScript.appendChild(iframe);
        callback?.();
    };

    const removeCyberSouceScripts = () => {
        const cyberHeader = document.getElementById("script_cyber_header");
        if (cyberHeader) {
            document.head.removeChild(cyberHeader);
        }

        const bodyDiv = document.getElementById("script_cyber_body");
        if (bodyDiv) {
            document.body.removeChild(bodyDiv);
        }

    };

    const getSessionId = () => {
        const scriptElement = document.getElementById("script_cyber_header");
        if (!scriptElement) return null;

        const scriptSrc = scriptElement.getAttribute("src");
        const sessionIdMatch = scriptSrc?.match(/session_id=([^&]+)/);
        return sessionIdMatch ? sessionIdMatch[1] : null;
    };

    const generateUUID = () => {
        const {
            merchantId,
        } = environment.api?.cybersource;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0,
                v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        }).replace(
            merchantId,
            ''
        );
    };

    return {
        addCyberSourceScripts,
        removeCyberSouceScripts,
        getSessionId,
    };
};

export default useCybersourceService;